import type { JSX } from "react";
interface ICustomPrismicHeadingProps {
  className?: string;
  before?: JSX.Element;
  after?: JSX.Element;
}

const CustomPrismicHeading =
  ({ className, before, after }: ICustomPrismicHeadingProps) =>
  (type, _element, _text, children, index) => {
    switch (type) {
      case 'heading1':
        return (
          <h1 className={className} key={index}>
            {before}
            {children}
            {after}
          </h1>
        );
      case 'heading2':
        return (
          <h2 className={className} key={index}>
            {before}
            {children}
            {after}
          </h2>
        );
      case 'heading3':
        return (
          <h3 className={className} key={index}>
            {before}
            {children}
            {after}
          </h3>
        );
      case 'heading4':
        return (
          <h4 className={className} key={index}>
            {before}
            {children}
            {after}
          </h4>
        );
      case 'heading5':
        return (
          <h5 className={className} key={index}>
            {before}
            {children}
            {after}
          </h5>
        );
      case 'heading6':
        return (
          <h6 className={className} key={index}>
            {before}
            {children}
            {after}
          </h6>
        );
      default:
        return null;
    }
  };

export default CustomPrismicHeading;
